const n = `<svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M113.315 31.5004C113.057 25.9578 109.276 20.9991 103.657 19.4962L72.4972 11.1583C69.6062 10.3829 66.6386 10 63.6711 10C60.7035 10 57.736 10.3829 54.845 11.1583L23.676 19.4962C18.0664 20.9991 14.2756 25.9578 14.0267 31.5004C13.9884 32.0461 13.9884 32.6109 14.0458 33.2044C15.5392 50.445 21.0627 78.8665 29.3814 95.1881C34.1008 105.622 43.2236 113.606 54.5004 116.746C57.5062 117.579 60.5886 118 63.6806 118C66.7631 118 69.8551 117.579 72.8609 116.746C84.1377 113.606 93.2605 105.622 97.9799 95.1881C106.299 78.8665 111.822 50.445 113.315 33.2044C113.363 32.6109 113.373 32.0461 113.335 31.5004H113.315Z"
    />
    <path
      d="M90.3199 41.0066C84.7555 37.0982 76.9719 38.5666 72.9531 44.2966L63.679 57.1147L54.405 44.2966C50.3752 38.5666 42.6026 37.0872 37.0382 41.0066C31.4737 44.9149 30.2151 52.7316 34.2449 58.4617L53.1795 84.6499C55.6967 88.2381 59.6824 90.1481 63.679 90.126C67.6757 90.1481 71.6614 88.227 74.1786 84.6499L93.1132 58.4617C97.143 52.7316 95.8844 44.9149 90.3199 41.0066Z"
      fill="#CB80DE"
    />
</svg>
`;
export {
  n as default
};
//# sourceMappingURL=insurance-3sPDXbTc.js.map
